import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const MyDatePicker = ({ startDate, endDate, setStartDate, setEndDate, handleApplyRange }) => {
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [selectedEndDate, setSelectedEndDate] = useState(null);

    const formatLabelDate = (date) =>
        date
            ? date.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            })
            : "";

    const formatAPIDate = (date) => {
        if (!date) return null;
        return date.toISOString().split("T")[0];
    };
    const parseAPIDate = (dateStr) => {
        if (!dateStr) return null;
        return new Date(dateStr);
    };

    const handleStartDateChange = (date) => {
        setSelectedStartDate(date);
        setStartDate(formatAPIDate(date));
    };

    const handleEndDateChange = (date) => {
        setSelectedEndDate(date);
        setEndDate(formatAPIDate(date));
    };

    const isApplyEnable = selectedStartDate && selectedEndDate

    const handleApply = () => {
        handleApplyRange(formatAPIDate(selectedStartDate), formatAPIDate(selectedEndDate))
    }

    useEffect(() => {
        if (startDate) {
            setSelectedStartDate(parseAPIDate(startDate));
        }
        if (endDate) {
            setSelectedEndDate(parseAPIDate(endDate));
        }
    }, [startDate, endDate]);


    return (
        <div className="flex items-end gap-4 p-4 bg-white rounded-lg border border-gray-200">
            <div className="flex flex-col gap-1">
                <label className="text-sm font-medium text-gray-700">
                    Start Date
                    {selectedStartDate && (
                        <span className="text-gray-500">
                            {" "}({formatLabelDate(selectedStartDate)})
                        </span>
                    )}
                </label>
                <DatePicker
                    selected={selectedStartDate}
                    onChange={handleStartDateChange}
                    placeholderText="Select date"
                    dateFormat="MM/dd/yyyy"
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={150}
                    className="h-[44px] w-[180px] rounded-md border border-gray-300 px-3 text-sm focus:border-blue-600 focus:outline-none"
                />
            </div>

            <div className="flex flex-col gap-1">
                <label className="text-sm font-medium text-gray-700">
                    End Date
                    {selectedEndDate && (
                        <span className="text-gray-500">
                            {" "}({formatLabelDate(selectedEndDate)})
                        </span>
                    )}
                </label>
                <DatePicker
                    selected={selectedEndDate}
                    onChange={handleEndDateChange}
                    placeholderText="Select date"
                    dateFormat="MM/dd/yyyy"
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={150}
                    className="h-[44px] w-[180px] rounded-md border border-gray-300 px-3 text-sm focus:border-blue-600 focus:outline-none"
                />
            </div>

            <button
                onClick={handleApply}
                disabled={!isApplyEnable}
                className={`h-[44px] px-6 rounded-md text-sm font-medium transition
                ${isApplyEnable
                        ? "bg-[#bb1ccc] text-white hover:bg-[#00008a] cursor-pointer"
                        : "bg-gray-200 text-gray-500 cursor-not-allowed"
                    }`}
            >
                Apply
            </button>

        </div>
    );
};

export default MyDatePicker;
